var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiPlannerRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67016 0L12.1947 10.7221L19.5652 13.6552L12.1947 17.3488L9.67016 27L7.14564 17.3488L0 13.6552L7.14564 10.7221L9.67016 0Z",
    fill: "#AB0101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4408 1.17383L19.2823 4.43709L21.7391 5.32975L19.2823 6.4539L18.4408 9.39122L17.5993 6.4539L15.2174 5.32975L17.5993 4.43709L18.4408 1.17383Z",
    fill: "#AB0101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7017 16.4348L22.5432 19.6981L25 20.5907L22.5432 21.7149L21.7017 24.6522L20.8602 21.7149L18.4783 20.5907L20.8602 19.6981L21.7017 16.4348Z",
    fill: "#AB0101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPlannerRed);
export default __webpack_public_path__ + "static/media/ai-planner-red.4d601d95a21b153d73043c3bc3310f06.svg";
export { ForwardRef as ReactComponent };